module.exports = __webpack_public_path__ + "static/media/activity-bg.446094b1.png";